// Icona auto vista dall'alto per i marker GPS; ruotata secondo la direzione di marcia se disponibile.
export function carIcon(g, color, heading, size = 38) {
  const rot = Number.isFinite(heading) ? Math.round(heading) : 0;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 40 40">
<g transform="rotate(${rot} 20 20)">
<ellipse cx="20" cy="21" rx="10" ry="17" fill="rgba(0,0,0,0.35)"/>
<path d="M14 4.5 Q20 2 26 4.5 Q30 6 30.5 11 L31 30 Q31 35.5 26 36.5 L14 36.5 Q9 35.5 9 30 L9.5 11 Q10 6 14 4.5 Z" fill="${color}" stroke="#F8FAFC" stroke-width="1.6"/>
<path d="M13 12 Q20 9.5 27 12 L25.6 17.5 Q20 16.2 14.4 17.5 Z" fill="#0B1220" opacity="0.88"/>
<path d="M14.4 29 Q20 30.2 25.6 29 L26.6 33 Q20 34.6 13.4 33 Z" fill="#0B1220" opacity="0.8"/>
<rect x="12.2" y="18.8" width="1.6" height="8.6" rx="0.8" fill="#0B1220" opacity="0.6"/>
<rect x="26.2" y="18.8" width="1.6" height="8.6" rx="0.8" fill="#0B1220" opacity="0.6"/>
<circle cx="13.6" cy="6.6" r="1.3" fill="#FEF9C3"/><circle cx="26.4" cy="6.6" r="1.3" fill="#FEF9C3"/>
</g></svg>`;
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
    scaledSize: new g.Size(size, size),
    anchor: new g.Point(size / 2, size / 2),
    labelOrigin: new g.Point(size / 2, size + 8),
  };
}
